<template>
  <div v-if="value">
    <div class="cc-modal-overlay"></div>
    <div class="cc-modal">
      <div class="cc-modal-header">
        <material-icons class="modal-close" icon="close" @click="close"></material-icons>
      </div>
      <div class="cc-modal-inner">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
import MaterialIcons from './Icon.vue'
export default {
  props: ['value'],
  methods: {
    close () {
      this.value = false;
      this.$emit('input', false);
    }
  },
  components: {MaterialIcons}
}
</script>

<style lang="scss" scoped>
  .cc-modal-overlay{
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.75);
    z-index: 9998;
    left: 0;
    top: 0;
  }
  .cc-modal{
    width: 500px;
    max-width: 100%;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    min-height: 300px;
    max-height: calc(100vh - 150px);
    background: #fff;
    top: 100px;
    z-index: 9999;
    .cc-modal-header{
      position: relative;
      .modal-close{
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
        z-index: 99;
      }
    }
  }
  .cc-modal-inner{
    position: relative;
  }
</style>
